import { ListboxButton } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ImgAvatarRounded } from "../atoms/ImgAvatarRounded";
import { SpanIconAnglesAvatar } from "../atoms/SpanIconAnglesAvatar";

type select = {
  id: number;
  name: string;
  avatar: string;
};
export type ButtonSelectAvatarprops = {
  selected: select | undefined;
};

export const ButtonSelectAvatar: FC<ButtonSelectAvatarprops> = ({
  selected,
}) => {
  return (
    <Fragment>
      <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500 sm:text-sm sm:leading-6">
        <span className="flex items-center">
          <ImgAvatarRounded src={selected?.avatar} />
          <span className="ml-3 block truncate text-gray-500">{selected?.name}</span>
        </span>
        <SpanIconAnglesAvatar />
      </ListboxButton>
    </Fragment>
  );
};
